import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import DataModel from '../../models/DataModel';
import _ from 'lodash';

import './AttachmentMetadata.scss';

export class AttachmentMetadata extends React.Component {
  constructor(props) {
    super(props);
    AttachmentMetadata.propTypes = {
      attachment: PropTypes.object,
    };

    this.state = {
      user: props.attachment.user,
    };
  }

  componentDidMount() {
    const { attachment } = this.props;

    if (!attachment.user && attachment.user_id) {
      DataModel.usersDAO.getUser(attachment.user_id).then(user => {
        this.setState({ user });
      });
    }
  }

  render() {
    const { attachment } = this.props;

    if (!attachment) {
      return null;
    }
    
    let { photo_taken_at, photo_latitude, photo_longitude, upload_updated_at } = attachment;
    const { user } = this.state;
    
    let display = [];
    if (user) {
      display.push(
        <p key='0'>
          {`Uploaded By: ${user.first_name} ${user.last_name}`}
        </p>
      );
    }
    
    let createDate = null;
    let createTime = null;
    
    let takenAtLabel = 'Taken At';
    let takenOnLabel = 'Uploaded On';
    if (attachment.location_source != 'photo') {
      // takenOnLabel = 'Uploaded On'
      takenAtLabel = 'Uploaded At';
    }

    // TODO: use exif once we have a reliable way to determine taken at source
    // if (!photo_taken_at) {
    photo_taken_at = upload_updated_at;
    // }
    if (photo_taken_at) {
      const timeZone = moment.tz.guess();
      if (photo_taken_at.created_at) {
        createDate = moment.tz(photo_taken_at.created_at, timeZone).format('MM/DD/YYYY');
        createTime = moment.tz(photo_taken_at.created_at, timeZone).format('h:mma z');
      }
      else {
        createDate = moment.tz(photo_taken_at, timeZone).format('MM/DD/YYYY');
        createTime = moment.tz(photo_taken_at, timeZone).format('h:mma z');
      }
      display.push(
        <p key='1'>
          {`${takenOnLabel}: ${createDate} ${createTime}`}
        </p>
      );
    }

    if (photo_latitude && photo_longitude) {
      display.push(
        <p key='2'>
          {`${takenAtLabel}: [${photo_latitude}, ${photo_longitude}]`}
        </p>
      );
    }
    return (
      <div className='AttachmentMetadata'>
        { display }
      </div>
    );
  }
}

export default AttachmentMetadata;



// WEBPACK FOOTER //
// ./src/components/AttachmentMetadata/index.js